import React, { useRef, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';

const TicketFinalPrint = ({
  mesa,
  pedidos,
  descuento_monto = 0,
  descuento_porcentaje = 0
}) => {
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const groupedItems = useMemo(() => {
    const map = new Map();

    pedidos.forEach(pedido => {
      pedido.items.forEach(item => {
        const precioUnitario = item.precio_unitario !== undefined
          ? item.precio_unitario
          : (item.price || 0);

        const key = `${item.nombre}-${precioUnitario}`;

        if (map.has(key)) {
          const existing = map.get(key);
          existing.cantidad += item.cantidad;
        } else {
          map.set(key, {
            ...item,
            precio_unitario_final: precioUnitario,
          });
        }
      });
    });

    return Array.from(map.values());
  }, [pedidos]);

  const totalSinDescuento = groupedItems.reduce(
    (sum, item) => sum + item.cantidad * item.precio_unitario_final,
    0
  );

  const descuentoPorcentajeCalculado = (descuento_porcentaje / 100) * totalSinDescuento;
  const totalDescuento = descuento_monto + descuentoPorcentajeCalculado;

  const totalFinal = Math.max(0, totalSinDescuento - totalDescuento);

  const mozo = pedidos[0]?.mozo || 'Mozo no asignado';

  return (
    <div>
      <div
        ref={printRef}
        style={{
          width: '58mm',
          margin: '0 auto',
          textAlign: 'center',
          fontFamily: 'monospace',
          fontSize: '12px',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
          <strong>TICKET FINAL</strong><br />
          Mesa: {mesa.name}<br />
          Comensales: {mesa.comensales_total || '-'}<br />
          Mozo: {mozo}<br />
          {new Date().toLocaleString()}
          <hr />
        </div>

        {groupedItems.map((item, idx) => (
          <div key={idx} style={{ marginBottom: '4px', textAlign: 'center' }}>
            <strong>{item.cantidad} x {item.nombre}</strong>
            <div>$ {(item.cantidad * item.precio_unitario_final).toFixed(2)}</div>
            {item.observacion && (
              <div style={{ fontSize: '10px', color: '#555' }}>
                ({item.observacion})
              </div>
            )}
          </div>
        ))}

        <hr />
        <div style={{ textAlign: 'center' }}>
          <div>Total sin descuento: $ {totalSinDescuento.toFixed(2)}</div>
          {descuento_porcentaje > 0 && (
            <div>Descuento %: -$ {descuentoPorcentajeCalculado.toFixed(2)}</div>
          )}
          {descuento_monto > 0 && (
            <div>Descuento fijo: -$ {descuento_monto.toFixed(2)}</div>
          )}
          {(descuento_monto > 0 || descuento_porcentaje > 0) && (
            <>
              <hr />
              <div style={{ fontWeight: 'bold' }}>
                Total final: $ {totalFinal.toFixed(2)}
              </div>
            </>
          )}
          {(descuento_monto === 0 && descuento_porcentaje === 0) && (
            <div style={{ fontWeight: 'bold' }}>
              Total: $ {totalSinDescuento.toFixed(2)}
            </div>
          )}
        </div>
      </div>

      <div className="text-center mt-2">
        <Button size="sm" variant="primary" onClick={handlePrint}>
          Imprimir ticket
        </Button>
      </div>
    </div>
  );
};

export default TicketFinalPrint;
